var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-container", [
        _c("div", { staticClass: "row justify-content-center" }, [
          _c(
            "div",
            { staticClass: "column w-75" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "mt-4 d-flex align-items-start justify-content-between"
                },
                [
                  _c("back-arrow", {
                    attrs: { title: _vm.$t("profile.title") }
                  }),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "ph-custom ph-pencil edit-btn",
                    on: { click: _vm.clickOnEditBtn }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-3" },
                [
                  _c("b-col", [
                    _c("div", { staticClass: "page-title" }, [
                      _vm._v(
                        _vm._s(_vm.user.firstname) +
                          " " +
                          _vm._s(_vm.user.lastname)
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-username" }, [
                      _vm._v(_vm._s(_vm.user.username))
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4 mb-4" },
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass: "category-card w-100 cursor-pointer",
                        on: { click: _vm.redirectMyLampions }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column align-items-center w-100"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex justify-content-center w-100"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "page-title lampions-nb mr-2"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.lampionsInfos.lampionsUser)
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("img", {
                                  staticClass: "coin-image mt-2",
                                  attrs: {
                                    src: require("@/assets/images/b122/ic_coin.png")
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "currentLoop mt-1 mb-2" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.lampionsInfos.currentLoop) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "w-100 d-flex flex-column align-items-center"
                              },
                              [
                                _c(
                                  "b-progress",
                                  {
                                    staticClass: "w-100 lampions-progress",
                                    attrs: {
                                      max:
                                        _vm.lampionsInfos.nbPointsInCurrentLoop,
                                      "no-value": ""
                                    }
                                  },
                                  [
                                    _c("b-progress-bar", {
                                      staticClass: "lampions-progress-bar",
                                      attrs: {
                                        value:
                                          _vm.lampionsInfos
                                            .currentNbOfPointsInLoop
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "lampions-progress-value" },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.lampionsInfos
                                            .currentNbOfPointsInLoop
                                        ) +
                                        " / " +
                                        _vm._s(
                                          _vm.lampionsInfos
                                            .nbPointsInCurrentLoop
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mb-4" },
                [
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass: "category-card mb-2 cursor-pointer",
                        on: { click: _vm.redirectMyMatches }
                      },
                      [
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c("h1", { staticClass: "category-card-title" }, [
                            _vm._v(_vm._s(_vm.$t("profile.matchs")))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "category-number" }, [
                            _vm._v(_vm._s(_vm.user.matchsOfUser))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center mr-5" },
                          [
                            _c("i", {
                              staticClass: "category-icon ph-flashlight-bold"
                            })
                          ]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c(
                      "div",
                      {
                        staticClass: "category-card",
                        on: { click: _vm.redirectMyAnnonce }
                      },
                      [
                        _c("div", { staticClass: "d-flex flex-column" }, [
                          _c("h1", { staticClass: "category-card-title" }, [
                            _vm._v(_vm._s(_vm.$t("profile.annonces")))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "category-number" }, [
                            _vm._v(_vm._s(_vm.user.annoncesOfUser))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center mr-5" },
                          [
                            _c("i", {
                              staticClass: "category-icon ph-megaphone-bold"
                            })
                          ]
                        )
                      ]
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", [
                    _c("div", { staticClass: "profile-property" }, [
                      _vm._v(_vm._s(_vm.$t("profile.dateBirth")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-value" }, [
                      _vm._v(
                        _vm._s(new Date(_vm.user.birthday).toLocaleDateString())
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("div", { staticClass: "profile-property" }, [
                      _vm._v(_vm._s(_vm.$t("profile.profession")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.user.profession ? _vm.user.profession.text : "-"
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("div", { staticClass: "profile-property" }, [
                      _vm._v(_vm._s(_vm.$t("profile.phone")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-value" }, [
                      _vm._v(_vm._s(_vm.user.phoneNumber))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("b-col", [
                    _c("div", { staticClass: "profile-property" }, [
                      _vm._v(_vm._s(_vm.$t("profile.department")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "profile-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.user.department ? _vm.user.department.text : "-"
                        )
                      )
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c("div", { staticClass: "profile-property" }, [
                      _vm._v(_vm._s(_vm.$t("profile.identity")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mt-1 d-flex align-items-center" },
                      [
                        _c("i", {
                          class:
                            (_vm.user && _vm.user.compte && _vm.user.compte.icon
                              ? _vm.user.compte.icon
                              : "") + " mr-1 ph-xl ph-bold",
                          style: { color: _vm.user.compte.color }
                        }),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.user.compte
                                ? _vm.$t(_vm.user.compte.text)
                                : ""
                            ) +
                            "\n            "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("b-col", { attrs: { cols: "3" } }, [
                    _c("div", { staticClass: "profile-property" }, [
                      _vm._v(_vm._s(_vm.$t("profile.rib")))
                    ]),
                    _vm._v(" "),
                    _vm.user.rib && _vm.user.rib.id
                      ? _c(
                          "div",
                          {
                            staticClass: "profile-value link-rib",
                            on: {
                              click: function($event) {
                                return _vm.clickOnRib()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.user.rib.originalFileName ||
                                    _vm.user.rib.fileName
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      : _c("div", { staticClass: "profile-value" }, [
                          _vm._v(
                            "\n              " + _vm._s("-") + "\n            "
                          )
                        ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("b-row", { staticClass: "justify-content-center mt-4 mb-4" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.user.askedToBeDeletedDate !== null
                        ? "delete-account-active"
                        : "delete-account",
                    on: { click: _vm.clickOnDeleteAccount }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.user.askedToBeDeletedDate !== null
                            ? _vm.$t("profile.delete.account.ongoing")
                            : _vm.$t("profile.delete.account")
                        ) +
                        "\n          "
                    )
                  ]
                )
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("AccountDeletionModal", {
        on: { hasValidatedAccountDeletion: _vm.hasValidatedAccountDeletion }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85f36208", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-85f36208","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/ProfileShow.vue
// module id = mhNc
// module chunks = 0